import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';

export default function ConfirmDialog({ isOpen, title, message, onConfirm, onCancel, isLoading = false }) {
  if (!isOpen) return null;

  return (
    <motion.div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="bg-Neautral-white rounded-[20px] p-6 sm:p-8 max-w-md w-full shadow-[0px_25px_55px_0px_rgba(126,126,126,0.25)]"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
      >
        <div className="flex items-start gap-3 sm:gap-4">
          <AlertCircle size={28} className="sm:w-8 sm:h-8 text-red-500 flex-shrink-0 mt-1" strokeWidth={1.5} />
          <div className="flex-1 min-w-0">
            <h3 className="text-lg sm:text-xl font-semibold text-Neautral-main font-opensans mb-2">
              {title}
            </h3>
            <p className="text-xs sm:text-sm text-Neautral-light font-opensans mb-6">
              {message}
            </p>
          </div>
        </div>

        <div className="flex flex-col-reverse sm:flex-row gap-3 sm:gap-4 justify-end">
          <motion.button
            onClick={onCancel}
            disabled={isLoading}
            className="px-6 py-2 rounded-[10px] bg-Neautral-base text-Neautral-main font-semibold font-opensans text-sm hover:bg-Neautral-light transition disabled:opacity-50"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            Avbryt
          </motion.button>
          <motion.button
            onClick={onConfirm}
            disabled={isLoading}
            className="px-6 py-2 rounded-[10px] bg-red-100 text-red-700 font-semibold font-opensans text-sm hover:bg-red-200 transition disabled:opacity-50"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            {isLoading ? 'Sletter...' : 'Slett'}
          </motion.button>
        </div>
      </motion.div>
    </motion.div>
  );
}
